import { DateTime } from '@ksyos/date-time';
import type { IPersonalSettingsServiceRightsUpdateEndDate } from '@common/validation/personalSettingsServiceRights';
import type {
    IServiceConsumer,
    IServiceEmployment,
    IServiceProvider,
    IServiceReaderWithServices,
    IServiceSupervisor,
} from '@frontend/components/interfaces/';
import { fetchJson } from '../../../../store/fetch';
import { StopRightsModal } from '../../../elements/StopRightsModal';

export interface IServiceRights {
    reloadServiceRights: () => Promise<void>;
    serviceConsumerRights: IServiceConsumer[];
    serviceEmploymentRights: IServiceEmployment[];
    serviceProviderRights: IServiceProvider[];
    serviceReaderRights: IServiceReaderWithServices[];
    serviceSupervisorRights: IServiceSupervisor[];
}

interface IServiceRightStopModalProps extends IServiceRights {
    alertMessage: string;
    bodyText: string;
    endDate: Date;
    onClose: () => void;
    organizationId: string;
    stopServiceGroup: boolean;
    title: string;
}

export function ServiceRightStopModal(props: IServiceRightStopModalProps) {
    const {
        alertMessage,
        bodyText,
        endDate,
        onClose,
        organizationId,
        reloadServiceRights,
        serviceConsumerRights,
        serviceEmploymentRights,
        serviceProviderRights,
        serviceReaderRights,
        serviceSupervisorRights,
        stopServiceGroup,
        title,
    } = props;

    return (
        <StopRightsModal
            alertMessages={[alertMessage]}
            bodyText={bodyText}
            endDate={DateTime.from(endDate).format('DD-MM-YYYY')}
            onClose={onClose}
            onStopRight={async () => await onStopRight()}
            title={title}
        />
    );

    async function onStopRight() {
        const body = buildBody();

        await fetchJson('/api/personalSettings/serviceRights/endDate', 'POST', body);
        await reloadServiceRights();
        onClose();
    }

    function buildBody() {
        const body: IPersonalSettingsServiceRightsUpdateEndDate = {
            organizationId: organizationId,
            stopServiceGroup: stopServiceGroup,
            serviceConsumerIds: serviceConsumerRights.map((serviceConsumer) => serviceConsumer.id),
            serviceProviderIds: serviceProviderRights.map((serviceProvider) => serviceProvider.id),
            serviceReaderIds: serviceReaderRights.map((serviceReader) => serviceReader.id),
            serviceSupervisorIds: serviceSupervisorRights.map((serviceSupervisor) => serviceSupervisor.id),
            serviceEmploymentIds: serviceEmploymentRights.map((serviceEmployment) => serviceEmployment.id),
        };

        return body;
    }
}
